import { render, staticRenderFns } from "./CardGradient.vue?vue&type=template&id=35355963&scoped=true&"
import script from "./CardGradient.vue?vue&type=script&lang=js&"
export * from "./CardGradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35355963",
  null
  
)

export default component.exports